import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  service;
  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    this.service = await this.getAdmin();
  }

  //이용약관 불러오기
  getAdmin(): Promise<any> {
    return this.db
      .doc$(`master/maumMaster`)
      .pipe(
        map(data => {
          return data.service;
        })
      )
      .pipe(first())
      .toPromise();
  }
}
